// extracted by mini-css-extract-plugin
module.exports = {"web-only":"Spacer_web-only__1HzgO"};